import React from "react";
//#region types
import { DrillDownTableEmptyRowProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { TableRow, TableCell } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const DrillDownTableEmptyRow: React.FC<DrillDownTableEmptyRowProps> = ({
  text,
  repeatPropertyKey,
  repeatPropertiesList,
  repeatPropertiesLength,
  repeatColumnLength,
  showTotal,
  className,
  sumNegative,
  sumValueRow,
}) => {
  const getColumnSumNegative = (repeatColumnIndex: number) => {
    return (
      sumNegative && repeatPropertyKey && sumValueRow && sumNegative(sumValueRow[repeatPropertyKey][repeatColumnIndex])
    );
  };

  return (
    <TableRow className={clsx(cssExports.tableRow, cssExports.empty, text ? cssExports.title : "", className)}>
      <TableCell className={clsx(cssExports.tableCell, cssExports.emptyCell, cssExports.first)}></TableCell>
      <TableCell
        className={clsx(cssExports.tableCell, repeatPropertiesList ? cssExports.freezeCell : "", cssExports.second)}
        colSpan={3}
      >
        {text}
      </TableCell>
      {repeatPropertiesList ? (
        [...Array(repeatColumnLength)].map((col, repeatIndex) => (
          <React.Fragment key={`repeat-columns-${repeatIndex}`}>
            {repeatPropertiesList.map(([repeatKey, cellValue], cellIndex) => (
              <TableCell
                key={`tab-repeatCell-${repeatIndex}${cellIndex}`}
                className={clsx(
                  cssExports.tableCell,
                  cellIndex === repeatPropertiesLength - 1 && (showTotal || repeatIndex !== repeatColumnLength - 1)
                    ? cssExports.repeatEnd
                    : "",
                  cellIndex === 0 ? cssExports.repeatTitleCell : cssExports.repeatCell,
                  cellValue?.isTextSmall ? cssExports.textSmall : "",
                  cellValue?.className,
                  cssExports.truncateString,
                  getColumnSumNegative(repeatIndex) ? cssExports.sumNegative : ""
                )}
                style={{
                  whiteSpace: cellValue?.noWrap ? "nowrap" : "normal",
                  width: cellValue?.width,
                  maxWidth: cellValue?.maxWidth,
                }}
              ></TableCell>
            ))}
          </React.Fragment>
        ))
      ) : (
        <></>
      )}
      {showTotal ? (
        <TableCell
          key={`tab-repeat-header-total`}
          className={clsx(cssExports.tableCell, cssExports.totalCell)}
        ></TableCell>
      ) : (
        <></>
      )}
      <TableCell className={clsx(cssExports.tableCell, cssExports.emptyCell, cssExports.last)}></TableCell>
    </TableRow>
  );
};

export default DrillDownTableEmptyRow;
